export default {
  startingBillingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
  endingBillingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
  coverageCertificateType: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/coverageCertificate/coverageCertificateValidationRules.js